<template>
  <div v-show="title === selectedTab.title" class="tab-content">
    <slot/>
  </div>
</template>

<script lang="ts" setup>

import {inject} from "vue";
import type {ITab} from "./tab.interface";

defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: false,
    default: '',
  },
  isLocked: {
    type: Boolean,
    required: false,
    default: false
  },
  badge: {
    type: Number,
    required: false,
    default: 0
  },
  // Neutral count shown next to the title (e.g. how many customers / reviews). Unlike `badge`
  // (a red notification pill), this renders as a muted count like on the team/resources page.
  count: {
    type: Number,
    required: false,
    default: undefined
  },
})

const selectedTab = inject<ITab>('selectedTab');

</script>

<style scoped lang="scss">
.tab-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

</style>
